define(["exports", "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose", "react", "styled-components"], function (_exports, _objectWithoutPropertiesLoose2, _react, _styledComponents) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = _exports.ModalFooter = void 0;
  _objectWithoutPropertiesLoose2 = _interopRequireDefault(_objectWithoutPropertiesLoose2);
  _react = _interopRequireDefault(_react);
  _styledComponents = _interopRequireDefault(_styledComponents);
  var _excluded = ["buttons"];

  var Footer = _styledComponents.default.div.withConfig({
    displayName: "ModalFooter__Footer",
    componentId: "sc-1dt8vsj-0"
  })(["text-align:right;margin-top:16px;button{+ button{margin:0 0 0 16px;}}"]);

  var ModalFooter = function ModalFooter(_ref) {
    var buttons = _ref.buttons,
        props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
    return /*#__PURE__*/_react.default.createElement(Footer, props, buttons);
  };

  _exports.ModalFooter = ModalFooter;
  var _default = ModalFooter;
  _exports.default = _default;
});